import styleInject from 'style-inject';
import { collectStyles } from '@lsg/ssr';

var reactStyles = ".lsgs-MS4xNC4w--navigation-block{position:relative;}.lsgs-MS4xNC4w--navigation-block-group{margin-bottom:8px;}.lsgs-MS4xNC4w--navigation-block__indent .lsgs-MS4xNC4w--navigation-block__page-group{padding-left:16px;}.lsgs-MS4xNC4w--navigation-block__process > .lsgs-MS4xNC4w--navigation-block-group{margin-left:-72px;}.lsgs-MS4xNC4w--navigation-block__process .lsgs-MS4xNC4w--navigation-block-group{padding-left:36px;}.lsgs-MS4xNC4w--navigation-block__cluster-item{margin-bottom:8px;padding:7px 0;}@media screen and (min-width:1024px){.lsgs-MS4xNC4w--navigation-block__cluster-item{padding:6px 0;}}";
var mainClass = "lsgs-MS4xNC4w--navigation-block";
styleInject(reactStyles);
collectStyles(reactStyles);

export { mainClass, reactStyles };
